import CollectionApi from './CollectionApi';

class SystemUserPublicKeysApi extends CollectionApi {
  constructor(id = '') {
    super(`/api/systemusers/${id}/sshKeys`, {
      skip: 0,
      limit: 100,
      sort: 'create_date',
    });
  }

  set id(value) {
    this.baseUrl = `/api/systemusers/${value}/sshKeys`;
  }
}

export default new SystemUserPublicKeysApi();
